import { CreateDiscountPayload, Discount } from '../types/pricing.types';
import { DiscountFilters } from './discount.state';

export const DISCOUNT_NAME = 'Discount';

export class CreateDiscountAction {
  static type = `[${DISCOUNT_NAME} CreateDiscountAction]`;

  constructor(public discount: CreateDiscountPayload) {}
}

export class SetDiscountAction {
  static type = `[${DISCOUNT_NAME} SetDiscountAction]`;

  constructor(
    public list: Discount[],
    public prependOnPage = false
  ) {}
}

export class GetDiscountAction {
  static type = `[${DISCOUNT_NAME} GetDiscountAction]`;

  constructor(
    public id: string,
    public prependToPage = false,
    public reload = false
  ) {}
}

export class UpdateDiscountAction {
  static type = `[${DISCOUNT_NAME} UpdateDiscountAction]`;

  constructor(public discount: Discount) {}
}

export class ApproveDiscountsAction {
  static type = `[${DISCOUNT_NAME} ApproveDiscountsAction]`;

  constructor(public discountIds: string[]) {}
}

export class DeleteDiscountsAction {
  static type = `[${DISCOUNT_NAME} DeleteDiscountsAction]`;

  constructor(public discountIds: string[]) {}
}

export class LoadDiscountsListAction {
  static type = `[${DISCOUNT_NAME} LoadDiscountsListAction]`;

  constructor(
    public filters: DiscountFilters,
    public pageToLoad = 1,
    public reload = false
  ) {}
}

export class LoadPartnerDiscountsListAction {
  static type = `[${DISCOUNT_NAME} LoadPartnerDiscountsListAction]`;

  constructor(public partnerId: string) {}
}
